import dayjs from 'libs/dayjs';

// Formatea un valor como fecha con un patrón dayjs (locale `es` ya configurado
// en libs/dayjs → MMMM = "junio"). Fallback seguro:
//   - vacío/null -> ''
//   - no parseable -> String(value) (nunca muestra "Invalid Date")
export function formatDate(value, pattern) {
  if (value == null || value === '') return '';
  const d = dayjs(value);
  if (!d.isValid()) return String(value);
  return d.format(pattern || 'YYYY-MM-DD');
}
